import React, { useState, useEffect } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import { despesasAPI } from '../../services/api';
import { toast } from 'react-toastify';

const DespesaModal = ({ despesa, onClose, onSave }) => {
  const isEdit = !!despesa;
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    prestador: '',
    valor: '',
    data_despesa: new Date().toISOString().split('T')[0],
    historico: ''
  });

  useEffect(() => {
    if (despesa) {
      setFormData({
        prestador: despesa.prestador,
        valor: despesa.valor,
        data_despesa: despesa.data_despesa.split('T')[0],
        historico: despesa.historico || ''
      });
    }
  }, [despesa]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.prestador || !formData.valor || !formData.data_despesa) {
      toast.error('Preencha todos os campos obrigatórios');
      return;
    }

    try {
      setLoading(true);
      
      if (isEdit) {
        await despesasAPI.update(despesa.id, formData);
        toast.success('Despesa atualizada com sucesso!');
      } else {
        await despesasAPI.create(formData);
        toast.success('Despesa cadastrada com sucesso!');
      }
      
      onSave();
    } catch (error) {
      const message = error.response?.data?.message || 'Erro ao salvar despesa';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{isEdit ? 'Editar Despesa' : 'Nova Despesa'}</h3>
          <button onClick={onClose} className="btn-close">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="prestador">Prestador / Fornecedor *</label>
            <input
              type="text"
              id="prestador"
              name="prestador"
              value={formData.prestador}
              onChange={handleChange}
              placeholder="Ex: Empresa X, Fornecedor Y..."
              required
              autoFocus
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="valor">Valor (R$) *</label>
              <input
                type="number"
                id="valor"
                name="valor"
                value={formData.valor}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
                min="0"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="data">Data *</label>
              <input
                type="date"
                id="data_despesa"
                name="data_despesa"
                value={formData.data_despesa}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="historico">Histórico / Observações</label>
            <textarea
              id="historico"
              name="historico"
              value={formData.historico}
              onChange={handleChange}
              placeholder="Informações adicionais sobre a despesa..."
              rows="3"
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={onClose}
              className="btn btn-secondary"
              disabled={loading}
            >
              <FaTimes /> Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              <FaSave /> {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DespesaModal;
